import {Button, Grid} from '@material-ui/core';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import locale from '../locale/Localization';
import NotaryContracts from './NotaryContracts';
import NotaryForm from './NotaryForm';
import NotaryFunctions from './NotaryFunctions';

const styles = {
  root: {width: '100%'},
  title: {paddingTop: '20px', paddingBottom: '20px'},
  button: {marginTop: '20px', color: 'white'}
};

/**
 * Component class of NotaryEdit
 */
export default class NotaryEdit extends Component {
  // eslint-disable-next-line require-jsdoc, max-lines-per-function
  constructor(props: props) {
    super(props);
  }

  /**
   * React render function.
   *
   * @return {string} - The function content.
   */
  render() {
    return (
      <div id='notary-edit-view' style={styles.root}>
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={10}>
            <Button
              style={styles.button}
              size='small'
              onClick={() => {
                this.props.onBackLinkClick();
              }}
              startIcon={<ArrowBackIosOutlinedIcon />}
            >
              {locale.back}
            </Button>
          </Grid>
        </Grid>
        <NotaryForm
          handleSubmit={this.props.handleSubmit}
          headline={locale.editNotary}
          data={this.props.notaryDetails}
          showSaveButton={true}
          showUserActionRow={true}
          hidePatentDate={true}
          saveButtonLabel={locale.saveButton}
        />
        <NotaryFunctions
          functions={this.props.notaryDetails.functions}
          personId={this.props.personId}
          certificate={this.props.notaryDetails.certificate}
          viewMode={this.props.viewMode}
        />
        <NotaryContracts
          personId={this.props.personId}
          editMode={true}
          signatureDeclaration={
            this.props.notaryDetails.signatureDeclarationDocument
          }
          termination={this.props.notaryDetails.terminationDocument}
          registration={this.props.notaryDetails.registrationDocument}
        />
      </div>
    );
  }
}

NotaryEdit.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  notaryDetails: PropTypes.object.isRequired,
  onBackLinkClick: PropTypes.func.isRequired,
  personId: PropTypes.number,
  viewMode: PropTypes.string.isRequired
};
